import { Component, Show, createMemo, createSignal } from "solid-js";
import type { ProjectQuotaStatus } from "../../api/types";
import {
  describeProjectQuotaStatus,
  projectQuotaDismissKey,
} from "../../utils/projectQuotaStatus";
import { QuotaNoticeStrip } from "./QuotaNoticeStrip";

/** FLOW-927: per-project companion to the tenant-level QuotaBanner (FLOW-791). */
export const ProjectQuotaBanner: Component<{
  status: ProjectQuotaStatus | undefined;
}> = (props) => {
  // One banner instance lives for the whole shell session and sees every
  // project the user switches to, so dismissal must be per-key: a single
  // slot would let dismissing project B's notice un-dismiss project A's.
  const [dismissed, setDismissed] = createSignal<ReadonlySet<string>>(
    new Set(),
  );
  const notice = createMemo(() =>
    props.status ? describeProjectQuotaStatus(props.status) : null,
  );
  const key = () =>
    props.status ? projectQuotaDismissKey(props.status) : null;
  const visible = () => {
    const k = key();
    return notice() !== null && k !== null && !dismissed().has(k);
  };
  // D5: the budget link needs figures to point at, same gate as the figure line.
  const action = () =>
    props.status?.usage
      ? {
          label: "View AI budget",
          href: `/projects/${props.status.project_id}/settings`,
        }
      : undefined;

  return (
    <Show when={visible() ? notice() : null}>
      {(n) => (
        <QuotaNoticeStrip
          notice={n()}
          testId="project-quota-banner"
          dismissLabel="Dismiss project budget notice"
          action={action()}
          onDismiss={() => {
            const k = key();
            if (k) setDismissed((prev) => new Set(prev).add(k));
          }}
        />
      )}
    </Show>
  );
};
